import { Routes, Route } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { appRoutes } from "./routes";

// *********** SLICK SLIDER ***********  //
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// *********** REACT TOASTIFY ***********  //
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// *********** IMPORT FILES ***********  //
import ProtectedRoute from "../hoc/protectedRoute";
import FullScreenLoader from "../Components/fullScreenLoader.jsx";
import { RootState } from "@store/store";
import CallReceiveModal from "src/Components/Customer/CallReceiveModal";
import ScrollToTop from "src/Components/ScrollToTop";
import PleaseLoginModal from "src/Components/PleaseLoginModal";
import HomeCareAppointementDrawer from "src/Components/Drawer/HomeCareAppointementDrawer";
import { toogleHomeCareAppointementDrawer } from "src/Store/reducer";

function Router() {
  const { showLoader } = useSelector((state: RootState) => state.appReducer);
  const { homeCareAppointementDrawer } = useSelector(
    (state: RootState) => state.appReducer
  );
  const dispatch = useDispatch();
  return (
    <>
      <ScrollToTop />
      <Routes>
        {appRoutes.map((item, index) => {
          return (
            <Route
              key={index}
              path={item.path}
              element={<ProtectedRoute item={item} />}
            />
          );
        })}
      </Routes>
      <FullScreenLoader show={showLoader} />
      <ToastContainer />
      <CallReceiveModal />
      <PleaseLoginModal />
      <HomeCareAppointementDrawer
        serviceId={homeCareAppointementDrawer || ""}
        onClose={() => dispatch(toogleHomeCareAppointementDrawer(null))}
        onSuccess={() => dispatch(toogleHomeCareAppointementDrawer(null))}
        isOpen={homeCareAppointementDrawer !== null}
      />
    </>
  );
}

export default Router;
